import { createSlice } from '@reduxjs/toolkit';
import { SpaceCategoriesViewState } from './types';

export const SPACE_CATEGORIES_VIEW_SLICE_NAME = 'spaceCategoriesView';

const initialState: SpaceCategoriesViewState = {
    hasPreparationFailed: false,
    isPreparing: false,
};

const spaceCategoriesViewSlice = createSlice({
    name: SPACE_CATEGORIES_VIEW_SLICE_NAME,
    initialState,
    reducers: {
        spaceCategoriesViewPreparationStarted: (state) => {
            state.hasPreparationFailed = false;
            state.isPreparing = true;
        },
        spaceCategoriesViewPreparationSucceeded: (state) => {
            state.hasPreparationFailed = false;
            state.isPreparing = false;
        },
        spaceCategoriesViewPreparationFailed: (state) => {
            state.hasPreparationFailed = true;
            state.isPreparing = false;
        },
    },
});

export const {
    spaceCategoriesViewPreparationSucceeded,
    spaceCategoriesViewPreparationFailed,
    spaceCategoriesViewPreparationStarted,
} = spaceCategoriesViewSlice.actions;

export const { reducer: spaceCategoriesViewReducer } = spaceCategoriesViewSlice;
